import { TempoSituacaoDeRuaEnum } from 'graphql/types.generated'
import { tempoSituacaoRuaRecord } from 'types/enums'

import { RadioGroupField, RadioGroupFieldProps } from './RadioGroupField'
import { recordToSortedRadioOptions } from './utils-field'

type TempoSituacaoDeRuaRadioGroupFieldProps = Readonly<
  Omit<RadioGroupFieldProps<TempoSituacaoDeRuaEnum>, 'label' | 'options'>
>

export function TempoSituacaoDeRuaRadioGroupField(props: TempoSituacaoDeRuaRadioGroupFieldProps) {
  return <RadioGroupField options={options} {...props} clearable />
}

const options = recordToSortedRadioOptions(tempoSituacaoRuaRecord)
